module.exports = __webpack_public_path__ + "img/health-details-active.ea1baeb4.svg";